import UserRepository from './user/userRepository';
import AppointmentsRepository from './appointments/appointmentsRepository';
import ClientsRepository from './clients/clientsRepository';
import CompaniesRepository from './companies/companiesRepository';
import LocationRepository from './location/locationsRepository';
import NewsRepository from './news/newsRepository';
import HcfRepository from './hcf/hcfRepository';
import FormsRepository from './forms/formsRepository';
import CodelistRepository from './codelist/codelistRepository';
import GalleryRepository from './gallery/galleryRepository';
import CreditRepository from './credit/creditRepository';
import CaptchaRepository from './recaptcha/recaptchaRepository';
import SharedFilesRepository from './sharedfiles/sharedFilesRepository';


const repositories = {
  user: UserRepository,
  appointments: AppointmentsRepository,
  clients: ClientsRepository,
  companies: CompaniesRepository,
  locations: LocationRepository,
  news: NewsRepository,
  hcf: HcfRepository,
  forms: FormsRepository,
  codelist: CodelistRepository,
  gallery: GalleryRepository,
  credit: CreditRepository,
  captcha: CaptchaRepository,
  sharedfiles: SharedFilesRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
